import { gql } from "@apollo/client";

export const USER_CERTIFICATIONS_QUERY = gql`
  query GetUserCertifications($trailblazerId: String, $queryProfile: Boolean!) {
    profileUser @client {
      isSelf @client
      id @client @export(as: "trailblazerId")
    }
    profile(trailblazerId: $trailblazerId) @include(if: $queryProfile) {
      __typename
      id
      ... on PublicProfile {
        credential {
          messages {
            __typename
            body
            header
            location
            cta {
              __typename
              label
              url
            }
            orientation
          }
          messagesOnly
          certifications {
            cta {
              __typename
              label
              url
            }
            dateCompleted
            dateExpired
            downloadUrl
            infoUrl
            logoUrl
            maintenanceDueDate
            product
            publicDescription
            status {
              __typename
              title
              date
              color
            }
            title
          }
        }
      }
    }
  }
`;
